import { render, staticRenderFns } from "./Bgg_Owners.vue?vue&type=template&id=1b84a4f4"
import script from "./Bgg_Owners.vue?vue&type=script&lang=js"
export * from "./Bgg_Owners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports